<template>
  <b-container class="p-0 px-sm-0">
    <b-card
      header-bg-variant="dark"
      header-border-variant="dark"
      header-text-variant="white"
      header-tag="header"
      border-variant="dark"
      class="main-card"
    >
      <template #header class="card-header px-0">
        <router-link to="/member/numbersets">
          <i class="fas fa-chevron-left"></i> จัดการเลขชุด
        </router-link>
      </template>
      <b-row>
        <b-col>
          <h5>
            <i class="fas fa-plus"></i> สร้างเลขชุด
          </h5>
        </b-col>
      </b-row>
      <div class="w-100 mt-2 mb-3 border-bottom"></div>
      <form
        accept-charset="utf-8"
        id="login"
        role="form"
        v-on:submit="saveNumberSet($event)"
      >
        <b-row>
          <b-col cols="12" sm="4" md="3" lg="2" xl="2" class="text-secondary">
            <label for="title">
              <i class="fas fa-list"></i> ชื่อชุด
            </label>
          </b-col>
          <b-col cols="12" sm="8" md="9" lg="10" xl="10">
            <b-form-input v-model="numberSetName" size="sm" id="title"></b-form-input>
          </b-col>
        </b-row>
        <div class="w-100 mt-2 mb-3 border-bottom"></div>
        <b-row>
          <b-col cols="12" class="text-secondary">
            <label for="title">
              <i class="fas fa-plus-square"></i> สร้างชุดตัวเลข
            </label>
          </b-col>
        </b-row>
        <b-row v-for="(item, index) in items" v-bind:key="index" class="mb-2">
          <b-col cols="12" sm="4" md="3" lg="2" xl="2" class="text-secondary">
            <b-input-group size="sm">
              <template #prepend>
                <b-input-group-text>
                  <strong>{{index + 1}}.</strong>
                </b-input-group-text>
              </template>
              <b-form-select
                :options="numberTypes"
                v-model="item.numberType"
                @change="item.number !== null && item.number.length > (numberTypes[item.numberType - 1].digit) ? item.number = null : true"
              ></b-form-select>
            </b-input-group>
          </b-col>
          <b-col cols="12" sm="8" md="9" lg="10" xl="10">
            <b-input-group size="sm">
              <template #append v-if="index > 0">
                <b-button variant="danger" @click="deleteItem(index)">
                  <i class="fas fa-trash-alt"></i>
                </b-button>
              </template>
              <input
                type="tel"
                class="form-control form-control-sm"
                id="title"
                v-model="item.number"
                :maxlength="(numberTypes[item.numberType - 1].digit)"
                @input="this.value=this.value.replace(/[^0-9]/g,'')"
              />
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-alert variant="primary" show class="mt-3">
              <b-button variant="outline-primary" block @click="addNumberSet">
                <i class="fas fa-plus-circle"></i> เพิ่มชุดตัวเลข
              </b-button>
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-button variant="secondary" block type="reset">ยกเลิก</b-button>
          </b-col>
          <b-col cols="6">
            <b-button variant="success" block type="submit">
              <i class="fas fa-save"></i> บันทึก
            </b-button>
          </b-col>
        </b-row>
      </form>
    </b-card>
  </b-container>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "Add",
  props: ["page", "id"],
  data() {
    return {
      numberSetName: null,
      numberTypes: [
        { value: 1, text: "3 ตัวบน", digit: 3 },
        { value: 2, text: "3 ตัวโต๊ด", digit: 3 },
        { value: 3, text: "2 ตัวบน", digit: 2 },
        { value: 4, text: "2 ตัวโต๊ด", digit: 2 },
        { value: 5, text: "วิ่งบน", digit: 1 },
        { value: 6, text: "2 ตัวล่าง", digit: 2 },
        { value: 7, text: "วิ่งล่าง", digit: 1 },
        { value: 8, text: "3 ตัวท้าย", digit: 3 }
      ],
      items: [{ numberType: 1, number: null }]
    };
  },
  mounted() {
    console.log(this.id);
  },
  methods: {
    saveNumberSet(e) {
      e.preventDefault();
      axios.post(this.getApiUrl + "/pingpong/addNumberSet",
        {
          username: this.getUsername,
          numberSetName: this.numberSetName,
          NumberSets: this.items
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        } )
        .then(response => {
          console.log(response);
          if(response.data.statusCode == 200) {
            this.$router.push("/member/numbersets");
          }
          // else {
          // }
        });
    },
    deleteItem(indexNumber) {
      this.items.splice(this.items[indexNumber], 1);
    },
    addNumberSet() {
      this.items.push({ numberType: 1, number: null });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
};
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.button {
  &-warning {
    background-color: #bd841b;
    border-color: #bd841b;
    color: #ffffff;
  }

  &-outline-warning {
    color: #bd841b;
    border-color: #bd841b;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: #bd841b;
    border-color: #bd841b;
    outline: none;
    box-shadow: none;
    color: #ffffff;
  }
}
</style>